<template>
    <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :close-on-backdrop="false" :centered="false" :title="title" :size="'lg'" :btn_cancel="true" :btn_ok="true" :booTitile="true">
        <div class="row d-flex flex-wrap align-items-end px-3">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label for="birthday" class="mb-1">DOCTOR</label>
                <div class="input-group input-group-sm">
                    <div class="input-group-text">
                        <span style="font-size: 20px; border: none" class="input-group-text">
                            <i class="fas fa-user"></i>
                        </span>
                    </div>
                    <v-select
                        id="serviceSelect"
                        class="form-control form-control-sm"
                        label="name"
                        :options="doctor"
                        placeholder="Buscar"
                        :reduce="(name) => name.id"
                        @search="mtdGetDoctor"
                        v-model="data_detail.doctor_id"
                    />
                </div>
            </div>

            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2" v-if="num==2">
                <label for="birthday" class="mb-1">PROCEDIMIENTO</label>
                <div class="input-group input-group-sm">
                    <div class="input-group-text">
                        <span style="font-size: 20px; border: none" class="input-group-text">
                            <i class="fas fa-scalpel"></i>
                        </span>
                    </div>
                    <input type="text" class="form-control form-control-sm" v-model="data_detail.procedure" placeholder="Procedimiento">
                </div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 mt-2">
                <label for="birthday" class="mb-1">ESTADO</label>
                <div class="input-group input-group-sm">
                    <div class="input-group-text">
                        <span style="font-size: 20px; border: none" class="input-group-text">
                            <i class="fas fa-solid fa-info-circle"></i>
                        </span>
                    </div>
                    <select class="form-control form-control-sm input-cantidad align-middle" v-if="num==1"
                        v-model="data_detail.state_patient" 
                    >
                        <option value="" disabled selected>Seleccione</option>
                        <option value="alta">ALTA</option>
                        <option value="altaVol">ALTA VOLUNTARIA</option>
                        <option value="fallecido">FALLECIDO</option>
                        <option value="hospitalizado">HOSPITALIZADO</option>
                        <option value="referido">REFERIDO</option>
                        <option value="retiro">RETIRO VOLUNTARIO</option>
                    </select>
                    <select class="form-control form-control-sm input-cantidad align-middle" v-if="num==2"
                        v-model="data_detail.state_patient"  
                    >
                        <option value="" disabled selected>Seleccione</option>
                        <option value="cancelado">CANCELADO</option>
                        <option value="pendiente">PENDIENTE</option>
                        <option value="realizado">REALIZADO</option>
                    </select>
                </div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 mt-2">
                <label for="birthday" class="mb-1">OBSERVACIÓN</label>
                <div class="input-group input-group-sm">
                    <div class="input-group-text">
                        <span style="font-size: 20px; border: none" class="input-group-text">
                            <i class="fas fa-solid fa-comment-dots"></i>
                        </span>
                    </div>
                    <input type="text" class="form-control form-control-sm" v-model="data_detail.observation" placeholder="Nombre">
                </div>
            </div>
        </div>
   
        <template #footer>
            <button class="btn btn-success btn-sm" @click="DataDetail" :disabled="cpButton">
                Editar
            </button>
            &nbsp;
        </template>
        <SweetAlert :swal="swal" ref="SweetAlert" />
    </CModal>
</template>

<script>
import CModal from "@/components/shared/modals/CModal.vue";
import {mapActions} from "vuex";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';

export default {
    name: "c-maintenance-modal-documento",
    components: {
        CModal,
        SweetAlert
    },
    data() {
        return {
            swal: null,
            data_detail: {
                state_patient: '',
                doctor_id: '',
                observation: '',
                procedure: ''
            },
            doctor: [],
            search:"",
        };
    },
    watch: {
        payload: {
            handler(newVal) {
                if (newVal) {
                    this.mtdDataDoctor();
                    this.data_detail = {
                        ...newVal,
                        state_patient: newVal.state_patient ?? ""
                    };
                }
            },
            immediate: true,
        },
    },
    props: {
        title: String,
        boo_modal: Boolean,
        payload: {
            type: Object,
            default: null
        },
        num: Number
    },
    computed: {
        cpButton() {
            return !(this.data_detail.doctor_id);
        }
    },
    methods: {
        ...mapActions(["get", "post"]),

        mtdDataDoctor: function () {
            this.get({
                url: this.$store.getters.get__url + "/reportPatient/mtdDataDoctor",
                token: this.$store.getters.get__token,
            })
            .then((response) => {
                this.doctor = response.data;
            })
            .catch((errors) => {
                this.$refs.SweetAlert.showError(errors);
            });
        },

        mtdGetDoctor: function (search, loading) {
            if (search.length > 3) {
                this.doctor = [];
                loading(true);
                this.get({
                    url: this.$store.getters.get__url + "/reportPatient/mtdGetDoctor/" + search,
                    token: this.$store.getters.get__token,
                })
                .then((response) => {
                    this.doctor = response.data;
                    loading(false);
                })
                .catch((errors) => {
                    this.$refs.SweetAlert.showError(errors);
                });
            }
        },

        mtdClose() {
            this.clear();
            this.$emit("closeModal");
        },

        clear() {
            this.data_detail = {
                state_patient: '',
                doctor_id: '',
                observation: '',
                procedure: ''
            },
            this.doctor = [],
            this.search = ""
        },

        DataDetail() {
            this.$emit('Datadetail', this.data_detail)
            this.mtdClose();
        },
    },
    

};
</script>